module.exports = __webpack_public_path__ + "img/delete-red-24dp.58aad667.svg";